import { ComponentsProps } from '@mui/material/styles';

export default function themeProps (): ComponentsProps {
  return {
    MuiSelect: {
      MenuProps: {
        elevation: 3,
      },
    },
  };
}
